import Gravity from 'Gravity';

const insightsFiltersModule = () => {
    document.querySelectorAll('.gg-insights-cards-with-filters').forEach((module) => {
        const showFiltersBtn = module.querySelector('.gg-insights-cards-with-filters__show-filters-btn > a');
        const hideFiltersBtn = module.querySelector('.gg-insights-cards-with-filters__hide-filters-btn > a');
        const resetBtn = module.querySelector('.gravity-block-filters__search-form__reset');

        if (showFiltersBtn === null || hideFiltersBtn === null) {
            return;
        }

        // Show Filters Button handling
        Gravity.clickEnterListener(showFiltersBtn, () => {
            module.classList.add('filters-shown');
        });

        // Hide Filters Button handling
        Gravity.clickEnterListener(hideFiltersBtn, () => {
            module.classList.remove('filters-shown');
        });

        // Switch focus to the counter part button on enter click
        [hideFiltersBtn, showFiltersBtn].forEach((btn) => {
            const counterPartBtn = hideFiltersBtn === btn ? showFiltersBtn : hideFiltersBtn;

            btn.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    counterPartBtn.focus();
                }
            });
        });

        // Reset Button Handling
        if (resetBtn === null) {
            return;
        }

        const handleModuleResetClass = (_reset) => {
            if (_reset.classList.contains('active')) {
                module.classList.add('reset-shown');
            } else {
                module.classList.remove('reset-shown');
            }
        };

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                const { target } = mutation;
                if (mutation.attributeName === 'class') {
                    handleModuleResetClass(target);
                }
            });
        });

        observer.observe(resetBtn, {
            attributes: true,
            attributeFilter: ['class'],
        });

        handleModuleResetClass(resetBtn);
    });
};

Gravity.ready(insightsFiltersModule);
